import { ReactElement } from 'react';
import { Check } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import cn from 'classnames';
import styles from './PlanCard.module.scss';

type PlanCardProps = {
  title: string;
  icon: React.ReactElement;
  description: string;
  features: (string | ReactElement)[];
  minPrice?: number;
  maxPrice?: number;
  isSuperNinja?: boolean;
};

export const PlanCard = ({
  title,
  icon,
  description,
  features,
  minPrice,
  maxPrice,
  isSuperNinja,
}: PlanCardProps) => {
  return (
    <div className={styles.planCardWrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <div className={styles.iconRow}>
            {icon}
            {minPrice && (
              <span className={styles.price}>
                ${minPrice}/mo ~ ${maxPrice}/mo
              </span>
            )}
          </div>

          <h4
            className={cn(styles.title, {
              [styles.superNinja]: isSuperNinja,
            })}
          >
            {title}
          </h4>
          <span className={styles.description}>{description}</span>
        </div>

        <div className={styles.featuresWrapper}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureRow}>
              <Check size={SVG_SIZE_M} />
              <span className={styles.featureText}>{feature}</span>
            </div>
          ))}
          <span className={styles.moreText}>and more</span>
        </div>
      </div>
    </div>
  );
};
